import { useContext, useRef } from 'react';

import { ImageObject } from 'types';

import { SingleProductContext } from 'contexts';

import { Carousel, Slide } from 'components/Carousel';
import { CarouselNavigation } from 'components/CarouselNavigation';
import { Image } from 'components/Image';
import { Modal } from 'components/Modal';

import * as S from './Gallery.styles';

type GalleryProps = {
  galleryUrls: ImageObject[];
};

export function Gallery(props: GalleryProps): React.ReactElement {
  const { galleryUrls } = props;

  const { isGalleryVisibleSet } = useContext(SingleProductContext);

  const swiper = useRef<any>(null); // eslint-disable-line

  const slides: Slide[] = galleryUrls?.map((item) => ({
    id: item.id.toString(),
    slide: (
      <S.Slide>
        <Image source={item.url} alt={item.key} />
      </S.Slide>
    ),
  }));

  return (
    <Modal asSecondaryStructure onClose={() => isGalleryVisibleSet(false)}>
      <S.Container>
        <CarouselNavigation instance={swiper} motive="carouselNavigationSecondary">
          <Carousel ref={swiper} slidesPerView={1} slides={slides} loop autoplay />
        </CarouselNavigation>
      </S.Container>
    </Modal>
  );
}
